module.exports = __webpack_public_path__ + "img/81.708ef820.jpg";